import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PayoutManagement from '@/components/PayoutManagement';
import AdminPayoutApproval from '@/components/AdminPayoutApproval';
import { useAuth } from '@/contexts/auth-context';
import { useSearchParams } from 'react-router-dom';
import { pageBg, wrap } from '@/components/ui/design';

export default function Payouts() {
    const { user } = useAuth();
    const [searchParams] = useSearchParams()
    const admin = searchParams.get('admin') || false;

    // Check if user is admin (you can modify this logic based on your user roles)
    const isAdmin = user?.roles?.includes('admin') || admin === 'true';

    return (
        <div className={`min-h-screen ${pageBg}`}>
            <Header />
            <main className={`${wrap} py-8 sm:py-12`}>
                {isAdmin ? (
                    <AdminPayoutApproval />
                ) : (
                    <PayoutManagement />
                )}
            </main>
            <Footer />
        </div>
    );
}
